import { BITF_CONFIGS as COMMON_BITF_CONFIGS } from '@common/configs/common-bitf.configs';

const ADMIN_BITF_CONFIGS = {};

export const BITF_CONFIGS = Object.assign(COMMON_BITF_CONFIGS, ADMIN_BITF_CONFIGS);
